const BaseModel = require('../BaseModel');

class BaseChannelTemplate extends BaseModel {
  static basePath = '/api/v1/templates/channels';
  static dataType = 'channel-message-template';

  static findParameters(text) {
    // find the parameter values
    const matches = text.match(/%{([^}^%]+)}/g) || [];

    // strip out the '%{' and '}'
    const strippedMatches = matches.map(val => val.slice(2, -1));

    // return only the unique items
    return Array.from(new Set(strippedMatches)).sort();
  }
}

BaseModel.models[BaseChannelTemplate.dataType] = BaseChannelTemplate;
module.exports = BaseChannelTemplate;
